/* eslint-disable */
import React from "react";
import { getPropertyInvitations } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const CoInvitations = ({ getPropertyInvitations, propertyInvitations, period }) => (
  <DataTable
    {...tablePresets.coInvitations}
    data={propertyInvitations}
    fetchData={getPropertyInvitations}
    period={period}
  />
);

const mapStateToProps = (state) => ({
  propertyInvitations: state.appProperties.propertyInvitations,
});

const mapDispatchToProps = (dispatch) => ({
  getPropertyInvitations: (payload) => dispatch(getPropertyInvitations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoInvitations);
